<template>
    <b-modal size="xl" button-size="sm" hide-footer v-model="showModal" :title="prefix + title"
        @hidden="closeModalCadastroPedido" @close="closeModalCadastroPedido">
        <ModalHistoricoPedido v-if="showModalHistoricoPedido" :title="' > Histórico de Pedido'"
            :prefix="'Pedido > Cadastro'" :almoxarifadoProdutoId="almoxarifadoProdutoId"
            @close="closeModalHistoricoPedido" @hidden="closeModalHistoricoPedido">
        </ModalHistoricoPedido>

        <ModalConsultaProduto v-if="showModalProduto" @onselect="addProduto" :title="' > Produtos do Almoxarifado'"
            :prefix="'Cadastro'" :departamento="form.departamentoSolicitante" @close="closeModalProduto"
            @hidden="closeModalProduto" :tipoOperacao="tipoOperacao"></ModalConsultaProduto>

        <b-form @submit.prevent="submit">
            <b-card>
                <b-form-row @keyup.enter="load">
                    <b-col lg="12" sm="12">
                        <LgFinderPageUnidadeAdministrativa id="finderDepartamento"
                            @onSelect="handleSelectDepartamento(item)" :prefix="'Pedidos'"
                            :title="' > Unidades Administrativas'" label="Solicitante:*"
                            invalidFeedback="Unidade Administrativa deve ser informada!"
                            v-model="form.departamentoSolicitante" :podeApagarDepartamento="false"
                            :podeMudarDepartamento="pedidoEmEditacao" />
                    </b-col>
                </b-form-row>
                <b-form-row>
                    <b-col>
                        <b-form-group label-for="textarea-formatter">
                            <label for="textarea-auto-height">Justificativa do pedido:*</label>
                            <b-form-textarea id="textarea-formatter" v-model="form.justificativa" :required="true" />
                        </b-form-group>
                    </b-col>
                </b-form-row>

                <b-tabs content-class="mt-3">
                    <b-tab title="Itens" active @click="activeTable = 'itens'">
                        <b-form-row>
                            <b-col cols="12" class="text-right mb-2">
                                <b-button id="adicionar" size="md" variant="success" style="height: 40px"
                                    @click="addProdutoIntent"><b-tooltip target="adicionar"
                                        title="Adicionar item ..."></b-tooltip>
                                    <div>Adicionar Produto</div>
                                </b-button>
                            </b-col>
                        </b-form-row>
                        <b-form-row>
                            <b-table id="t-pedido-item" responsive class="mt-2" :busy="this.busy" small
                                :items="form.itens" :fields="fieldsTabelaItens" show-empty>
                                <template #table-busy>
                                    <div class="text-center text-primary my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                    </div>
                                </template>

                                <template #empty>
                                    <h6 style="text-align: center">Nenhum produto vinculado</h6>
                                </template>

                                <template v-slot:cell(historico)="{ item }" v-if="pedidoEmEditacao">
                                    <b-button id="historico" size="sm" variant="primary" @click="historicoPedido(item)">
                                        <b-icon icon="clock" />
                                        <b-tooltip target="historico" title="Histórico de pedidos..."></b-tooltip>
                                    </b-button>
                                </template>

                                <template v-slot:cell(remover)="{ item }" v-if="pedidoEmEditacao">
                                    <b-button id="remover" size="sm" variant="danger" @click="removerItem(item)">
                                        <b-icon icon="trash" />
                                        <b-tooltip target="remover" title="Remover item do pedido..."></b-tooltip>
                                    </b-button>
                                </template>

                                <template #cell(qtdSolicitada)="data">
                                    <lg-number v-model="form.itens[data.index].qtdSolicitada" required
                                        :precision="{ min: 2, max: 2 }" />
                                </template>
                            </b-table>
                        </b-form-row>

                        <div class="d-flex justify-content-center">
                            <div class="text-right">
                                <b-button id="salvar" type="submit" variant="success" size="sm" v-if="pedidoEmEditacao"
                                    pill :title="'Salvar'">
                                    <b-tooltip target="salvar" title="Salvar"></b-tooltip>
                                    <div class="btn-size-alinhamento">
                                        <b-icon icon="check-circle" />
                                    </div>
                                </b-button>

                                <b-button id="cancelarSalvar" class="ml-2" @click="close" variant="danger" pill
                                    size="sm" v-if="pedidoEmEditacao">
                                    <b-tooltip target="cancelarSalvar" title="Cancelar"></b-tooltip>
                                    <div class="btn-size-alinhamento">
                                        <b-icon icon="x-circle" />
                                    </div>
                                </b-button>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab title="Arquivos" @click="activeTable = 'arquivos'">
                        <b-form-row>
                            <b-col cols="12" class="text-right mb-2">
                                <div>
                                    <label for="fileInput" class="file-input-label cursor-pointer">
                                        <div class="d-flex align-items-center">
                                            <clip-img-comp id="clip"></clip-img-comp>
                                        </div>
                                    </label>
                                    <input type="file" id="fileInput" ref="fileInput" multiple
                                        @change="handleFileChange" style="display: none" />
                                    <b-tooltip :target="'clip'" title="Adicionar Arquivos..."></b-tooltip>
                                </div>
                            </b-col>
                        </b-form-row>
                        <b-table id="t-pedido-arquivo" responsive class="mt-2" :busy="this.busy" small hover
                            :items="form.arquivos" :fields="fieldsTabelaArquivos" show-empty>

                            <template #table-busy>
                                <div class="text-center text-primary my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                            </template>


                            <template #empty>
                                <h6 style="text-align: center">Nenhum arquivo vinculado</h6>
                            </template>

                            <template #cell(nome)="data">
                                <a :href="getFileUrl(data.item.arquivo)" :download="data.item.nome">
                                    {{ data.item.nome }}
                                </a>
                            </template>

                            <template v-slot:cell(removerArquivo)="{ item }" v-if="arquivoEmEditacao">
                                <b-button :id="`removerArquivo-${item.id}`" size="sm" variant="danger"
                                    @click="removerArquivo(item)">
                                    <b-icon icon="trash" />
                                    <b-tooltip :target="`removerArquivo-${item.id}`"
                                        title="Remover arquivo do pedido..."></b-tooltip>
                                </b-button>
                            </template>
                        </b-table>

                        <div class="d-flex justify-content-center">
                            <div class="text-right">
                                <b-button id="salvar" type="submit" variant="success" size="sm" v-if="pedidoEmEditacao"
                                    pill style="height: 20px" :title="'Salvar'">
                                    <b-tooltip target="salvar" title="Salvar"></b-tooltip>
                                    <div class="btn-size-alinhamento">
                                        <b-icon icon="check-circle" />
                                    </div>
                                </b-button>

                                <b-button id="cancelar" class="ml-2" @click="close" variant="danger" pill
                                    style="height: 20px" size="sm" v-if="pedidoEmEditacao">
                                    <b-tooltip target="cancelar" title="Cancelar"></b-tooltip>
                                    <div class="btn-size-alinhamento">
                                        <b-icon icon="x-circle" />
                                    </div>
                                </b-button>
                            </div>
                        </div>
                    </b-tab>
                </b-tabs>
            </b-card>
        </b-form>

        <b-modal v-model="showModalMonitoramento" title="Este item possui monitoramento de consumo!" size="lg"
            hide-footer>

            <div class="mb-3">
                {{ textoMonitoramento }}
            </div>
            <strong>Histórico de Consumo - {{ form.departamentoSolicitante.sigla }}</strong>
            <b-table small :items="itemTabelaMonitoramento" :fields="fieldsMonitoramento" responsive class="mt-3">
            </b-table>

            <div class="text-center mt-4">
                <b-button variant="success" class="mr-2" @click="addProdutoNaListaAndFecharModalMonitoramento">
                    CONTINUAR MESMO ASSIM
                </b-button>

                <b-button variant="danger" @click="funcaoHideMonitoramento">
                    CANCELAR ITEM
                </b-button>
            </div>

        </b-modal>
    </b-modal>
</template>
<script>
import { required } from "vuelidate/lib/validators"
import ItensConsumidosService from "@/core/api/ItensConsumidosService"

import ConfirmMixin from "@/core/mixins/confirm"
import Formatters from "@/core/mixins/formatters"
import Resource from "@/core/mixins/resource"
import ClipImgComp from "@/components/Svgs/ClipImg.vue"
import ResourceService from "@/core/api/ResourceService"
import LgNumber from "@/core/components/Inputs/LgNumber.vue"
import LgFinderPageUnidadeAdministrativa from "@/components/Finders/LgFinderPageUnidadeAdministrativa.vue"
import ModalConsultaProduto from "@/core/components/Modals/ModalConsultaProduto.vue"
import ModalHistoricoPedido from "@/core/components/Modals/ModalHistoricoPedido.vue"
import DownloadArquivoUtil from "@/core/utils/DownloadArquivoUtil"
import TipoOperacaoAlmoxarifadoProdutoEnum from "@/core/utils/TipoOperacaoAlmoxarifadoProdutoEnum"

export default {
    mixins: [Formatters, ConfirmMixin, Resource.FormResourceMixin],
    components: {
        LgFinderPageUnidadeAdministrativa,
        LgNumber,
        ModalHistoricoPedido,
        ModalConsultaProduto,
        ClipImgComp,
    },

    created() {
        const brand = JSON.parse(localStorage.getItem("context"))
        this.form.departamentoSolicitante = brand.departamento
    },

    props: {
        id: {
            type: Number,
            default: null,
        },
        prefix: {
            type: String,
            default: "Pedido",
        },
        title: {
            type: String,
            default: " > Cadastro",
        },
    },

    data() {
        return {
            textoMonitoramento: "",
            showModalMonitoramento: false,
            itemTabelaMonitoramento: [],
            tipoOperacao: TipoOperacaoAlmoxarifadoProdutoEnum.PEDIDO,
            files: [],
            showModal: true,
            showModalProduto: false,
            showModalHistoricoPedido: false,
            almoxarifadoProdutoId: null,
            busy: false,
            activeTab: "itens",
            form: {
                departamentoSolicitante: {},
                departamentoResponsavel: {},
                situacao: 1,
                itens: [],
                status: {},
                justificativa: "",
                arquivos: [
                    {
                        nome: "",
                        arquivo: "",
                    },
                ],
            },
        }
    },

    validations: {
        form: {
            justificativa: { required },
            itens: { required },
        },
    },
    async beforeMount() {
        this.$service = new ResourceService(`/api/pedidos`)
        this.$serviceProduto = new ResourceService(`/api/produto`)
        this.$departamentoService = new ResourceService(`/api/departamentos`)
        this.$pessoaService = new ResourceService(`/api/pessoa`)
        this.$serviceStatus = new ResourceService(`/api/status`)
        this.$ItensConsumidosService = new ItensConsumidosService()

        await this.carregarPedido()
    },

    mounted() { },

    computed: {
        "form.departamento"() {
            return this.form.departamento === ""
        },

        fieldsMonitoramento() {
            return [
                {
                    key: "descricaoResumida",
                    label: "Produto",
                    tdClass: "py-0 ",
                    tdStyle: "width: 40%",
                },
                {
                    key: "periodoMonitoramento",
                    label: "Período (dias)",
                    tdClass: "py-0 ",
                    tdStyle: "width: 40%",
                },
                {
                    key: "quantidade",
                    label: "Quantidade",
                    tdClass: "py-0 ",
                    tdStyle: "width: 5%",
                },
                {
                    key: "tipoMedida.descricao",
                    label: "Unidade",
                    tdClass: "py-0 ",
                    tdStyle: "width: 5%",
                },
            ];
        },
        fieldsTabelaItens() {
            if (this.pedidoEmEditacao && this.activeTab === "itens") {
                return [
                    {
                        key: "almoxarifadoProduto.produto.numero",
                        label: "Número",
                        tdClass: "py-0 ",
                        tdStyle: "width: 10%",
                    },
                    {
                        key: "almoxarifadoProduto.produto.descricaoResumida",
                        label: "Produto",
                        tdClass: "py-0 ",
                        tdStyle: "width: 40%",
                    },
                    {
                        key: "almoxarifadoProduto.almoxarifado.descricao",
                        label: "Almoxarifado",
                        tdClass: "py-0 ",
                        tdStyle: "width: 40%",
                    },
                    {
                        key: "qtdSolicitada",
                        label: "Solicitar",
                        tdClass: "py-0 ",
                        tdStyle: "width: 5%",
                    },
                    {
                        key: "remover",
                        label: "",
                        tdClass: "py-0 ",
                        tdStyle: "width: 3%",
                    },
                    {
                        key: "historico",
                        label: "",
                        tdClass: "py-0 ",
                        tdStyle: "width: 2%",
                    },
                ]
            }

            return [
                {
                    key: "almoxarifadoProduto.produto.numero",
                    label: "NÚMERO",
                    tdClass: "py-0 col-2",
                    thStyle: "font-size: 16px; font-weight: 600;",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: "almoxarifadoProduto.produto.descricaoResumida",
                    label: "PRODUTO",
                    tdClass: "py-0 col-4",
                    thStyle: "font-size: 16px; font-weight: 600;",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: "almoxarifadoProduto.almoxarifado.descricao",
                    label: "ALMOXARIFADO",
                    tdClass: "py-0 col-3",
                    thStyle: "font-size: 16px; font-weight: 600;",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: "quantidadeDevolvida",
                    label: "DEVOLVER",
                    tdClass: "py-0 col-1",
                    thStyle: "font-size: 16px; font-weight: 600;",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: "quantidadeAprovado",
                    label: "APROVADO",
                    tdClass: "py-0 col-1",
                    thStyle: "font-size: 16px; font-weight: 600;",
                    tdStyle: "font-size: 13px",
                },
            ]
        },

        fieldsTabelaArquivos() {
            return [
                {
                    key: "nome",
                    label: "Arquivo",
                    tdClass: "py-0 col-8",
                    thStyle: "font-size: 16px; font-weight: 600;",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: "situacao",
                    label: "Situação",
                    tdClass: "py-0 col-2",
                    thStyle: "font-size: 16px; font-weight: 600;",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: "removerArquivo",
                    label: "",
                    tdClass: "w-4",
                    thStyle: "font-size: 16px; font-weight: 600;",
                    tdStyle: "font-size: 13px",
                },
            ]
        },

        pedidoEmEditacao() {
            return this.form.status.id === 26
        },

        arquivoEmEditacao() {
            const hasFiles = this.form.arquivos && this.form.arquivos.length > 0
            return hasFiles
        },
    },

    methods: {
        funcaoShowMonitoramento() {
            this.showModalMonitoramento = true;
        },

        funcaoHideMonitoramento() {
            this.showModalMonitoramento = false;
        },
        async carregarPedido() {
            this.busy = true
            try {
                if (this.id) {
                    const { data } = await this.$service.findById(this.id)
                    this.form = {
                        ...data,
                        arquivos: data.arquivo,
                    }
                } else {
                    const brand = JSON.parse(localStorage.getItem("context"))
                    this.form = {
                        departamentoSolicitante: brand.departamento,
                        departamentoResponsavel: brand.departamento,
                        situacao: 1,
                        itens: [],
                        status: {},
                        justificativa: "",
                        arquivos: [],
                    }
                }

                const { data } = await this.$serviceStatus.findById(26)
                this.form.status = data
            } catch (error) {
                console.error("Erro ao carregar o pedido:", error)
            } finally {
                this.busy = false
            }
        },

        getFileUrl(base64Data) {
            if (!base64Data) return "#"
            return `data:application/octet-stream;base64,${base64Data}`
        },

        showDocument(item) {
            if (item.id) {
                let id = item.id
                this.$ItemRepositorioDocumentoService.findById(id).then(response => {
                    let arquivo = response.data.arquivoBase64
                    let nome = response.data.nome
                    DownloadArquivoUtil(arquivo, nome)
                })
            } else {
                DownloadArquivoUtil(item.arquivo, item.nome)
            }
        },

        handleFileChange(event) {
            const files = event.target.files
            this.convertToBase64(files)
        },

        async addProdutoIntent() {
            this.showModalProduto = true
        },

        historicoPedido(item) {
            this.almoxarifadoProdutoId = item.almoxarifadoProduto.id
            this.showModalHistoricoPedido = true
        },

        closeModalHistoricoPedido() {
            this.showModalHistoricoPedido = false
        },

        getDataMenosDias(qtdDias) {
            const hoje = new Date();

            hoje.setDate(hoje.getDate() - qtdDias);

            const dia = String(hoje.getDate()).padStart(2, '0');
            const mes = String(hoje.getMonth() + 1).padStart(2, '0');
            const ano = hoje.getFullYear();

            return `${dia}/${mes}/${ano}`;
        },
        async addProduto(produto) {


            const produtoExistente = this.form.itens.find(
                item => item.almoxarifadoProduto.id === produto.id
            )
            if (produtoExistente) {
                this.$notify({
                    type: "warning",
                    message: "Esse Item já se encontra na lista",
                })
                return
            }

            this.busy = true;
            const { data } = await this.$serviceProduto.findById(produto.produto.id)
            this.produtoSelecionadoModalSelecaoProduto = produto

            if (data.monitorado === 1) {
                this.textoMonitoramento = data.tipoTexto === 1
                    ? data.textoEspecifico
                    : (await new ResourceService("/api/configuracoes-sistema").get("287")).data.valorPropriedade

                data.quantidade = (await this.$ItensConsumidosService.getSomaItensPedidosRetirada({ dataDe: this.getDataMenosDias(data.periodoMonitoramento ? data.periodoMonitoramento : 0), produtoId: data.id, departamentoId: this.form.departamentoSolicitante.id })).data;
                data.quantidade = data.quantidade || data.quantidade != "" ? data.quantidade : 0;

                this.itemTabelaMonitoramento = [data]

                this.showModalMonitoramento = true
            } else {
                this.addProdutoNaLista()
            }

            this.busy = false;

        },
        addProdutoNaListaAndFecharModalMonitoramento() {
            this.addProdutoNaLista();
            this.funcaoHideMonitoramento();
        },
        addProdutoNaLista() {
            this.form.itens.push({
                almoxarifadoProduto: {
                    id: this.produtoSelecionadoModalSelecaoProduto.id,
                    produto: {
                        id: this.produtoSelecionadoModalSelecaoProduto.produto.id,
                        numero: this.produtoSelecionadoModalSelecaoProduto.produto.numero,
                        descricaoResumida: this.produtoSelecionadoModalSelecaoProduto.produto.descricaoResumida,
                    },
                    almoxarifado: {
                        id: this.produtoSelecionadoModalSelecaoProduto.almoxarifado.id,
                        descricao: this.produtoSelecionadoModalSelecaoProduto.almoxarifado.descricao,
                    },
                },
            });

        },

        convertToBase64(files) {
            const promises = Array.from(files).map(file => {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader()
                    reader.onload = () => {
                        const base64Data = reader.result.split(",")[1]
                        const fileName = file.name
                        resolve({ base64Data, fileName })
                    }
                    reader.onerror = error => reject(error)
                    reader.readAsDataURL(file)
                })
            })

            Promise.all(promises)
                .then(base64Array => {
                    base64Array.forEach(b64A => {
                        this.form.arquivos.push({
                            nome: b64A.fileName,
                            arquivo: b64A.base64Data,
                        })
                    })
                })
                .catch(error => {
                    this.$notify({
                        type: "danger",
                        message: error,
                    })
                })
        },

        closeModalProduto() {
            this.showModalProduto = false
        },

        closeModalCadastroPedido() {
            this.showModal = false
            this.$emit("close")
        },

        close() {
            this.$emit("close")
        },

        handleSelectDepartamento(departamento) {
            if (this.form.departamentoSolicitante.nome != undefined) {
                this.form.departamentoSolicitante = departamento
            }
        },

        removerItem(item) {
            this.$confirm(
                "Deseja realmente remover o item do pedido?",
                "Remover Item"
            ).then(response => {
                if (response) {
                    const index = this.form.itens.findIndex(
                        ({ almoxarifadoProduto }) =>
                            almoxarifadoProduto.id === item.almoxarifadoProduto.id
                    )
                    if (index !== -1) {
                        this.form.itens.splice(index, 1)
                    } else {
                        this.$notify({
                            type: "warning",
                            message: "Item não encontrado na lista.",
                        })
                    }
                }
            })
        },

        removerArquivo(item) {
            this.$confirm(
                "Deseja realmente remover o arquivo do pedido?",
                "Remover Arquivo"
            ).then(response => {
                if (response) {
                    const index = this.form.arquivos.findIndex(({ id }) => id === item.id)
                    if (index !== -1) {
                        this.form.arquivos.splice(index, 1)
                    } else {
                        this.$notify({
                            type: "warning",
                            message: "Arquivo não encontrado na lista.",
                        })
                    }
                }
            })
        },

        async submit() {
            if (!this.formIsValid || !this.form.justificativa || this.form.justificativa == "") {
                this.$v.$touch()
                this.$notify({
                    type: "danger",
                    message: "Verifique os campos do cadastro.",
                })
                return
            }

            if (this.form.itens.length == 0) {
                this.$v.$touch()
                this.$notify({
                    type: "danger",
                    message: "É preciso informar um item.",
                })
                this.addItem()
                return
            }
            const filtro = {}
            if (
                this.form.departamentoSolicitante != undefined &&
                this.form.departamentoSolicitante.id != undefined
            ) {
                filtro.departamentoSolicitanteId = this.form.departamentoSolicitante.id
            }

            filtro.departamentoResponsavelId = this.form.departamentoResponsavel.id

            if (this.form.itens != undefined && this.form.itens.length > 0) {
                filtro.itens = this.form.itens
            }

            filtro.justificativa = this.form.justificativa

            if (this.form.arquivos != undefined && this.form.arquivos.length > 0) {
                filtro.arquivos = this.form.arquivos
            }

            if (this.form.status != undefined && this.form.status.id != undefined) {
                filtro.statusId = this.form.status.id
            }

            if (this.id != undefined && this.id != "") {
                filtro.id = this.id
            }

            this.busy = true;

            try {

                await this.$saveResource(filtro, "", false, {}, false, true);

                this.closeModalCadastroPedido()

            }
            catch (error) {
                this.busy = false;
                this.$notify({
                    type: "danger",
                    message: error.response.data,
                });
            }

        },
    },
}
</script>

<style scoped lang="scss">
.link-style td {
    color: #0a2c4e !important;
    font-weight: 500;
    cursor: pointer;
    text-decoration: underline;
}

.cursor-pointer {
    cursor: pointer;
}

.in-progress {
    color: red;
    margin: 25px 0;
}

table {
    .form-control {
        padding: 3px 9px;
        height: 30px;
        text-align: right;
    }
}
</style>
